import { IList, IRecord } from 'annotation-tools/utils';
import {
  APIRawValidationErrorType,
  APIValidationErrorType,
  IAPIValidationErrorType
} from '../common/validation-error';
import { ImageInfoAPIRawSuccessResponseType } from '../image-info/api-response';
import {
  ProjectImageInfoAPIRawRequestBodyType,
  ProjectImageInfoAPIRequestBodyType
} from './api-request-body';

export type ProjectImageInfoAPIRawSuccessResponseType = ImageInfoAPIRawSuccessResponseType & {
  model_id: number | undefined | null;
};

export type ProjectImageInfoAPIRawValidationErrorType = APIRawValidationErrorType<
  ProjectImageInfoAPIRawRequestBodyType
>;

export type ProjectImageInfoAPIValidationErrorType = APIValidationErrorType<
  ProjectImageInfoAPIRequestBodyType
>;

export type IProjectImageInfoAPIValidationErrorType = IAPIValidationErrorType<
  ProjectImageInfoAPIRequestBodyType
>;

export const IProjectImageInfoAPIValidationErrorFactory = IRecord<
  ProjectImageInfoAPIValidationErrorType
>({
  cropRect: IList<string>(),
  fileGuid: IList<string>(),
  modelId: IList<string>(),
  name: IList<string>()
});
